import Vue from 'vue'
/**
 * 自定义指令 v-reset-page，以解决 iOS 12 中键盘收起后页面底部有留白的问题
 */

Vue.directive('resetPage', {
  inserted: function (el) {
    // let m = navigator.userAgent
    // let isAndroid = m.indexOf('Android') > -1 || m.indexOf('Adr') > -1 // android终端
    // let isIos = !!m.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    // 监听键盘收起事件
    // if (isIos) {
    document.body.addEventListener('focusout', () => {
      setTimeout(() => {
        console.log('focusout')
        window.scrollTo(0, 0)
      }, 100)
    })
    // focus事件
    el.addEventListener('focusin', () => {
      el.focus()
      setTimeout(() => {
        console.log('focusin')
        document.activeElement.scrollIntoViewIfNeeded()
      }, 100)
    })
    // }
  }
})
